<template>
    <div>
        <div class="form-info">
            <div class="form-row">
                <div class="form-value" style="width:300px;">
                    <button class="swb-btn swb-btn-small" @click="toSelectAssetStockInItem(voucherId, ioFlag, goodsRecvVoucherItemList)">
                        <span>选择条目</span>
                    </button>
                </div>
                <div class="fr">
                    <div class="form-label" v-if="!autoInFiscal && !lowCostFlag">
                        <label>&nbsp;</label>
                    </div>
                    <div class="form-value" v-if="!autoInFiscal && !lowCostFlag">
                        <div class="pos-rel">
                            <el-checkbox v-model="autoFiscalIn">自动入账</el-checkbox>
                        </div>
                    </div>
                    <div class="form-label" v-if="autoFiscalIn">
                        <label>&nbsp;</label>
                    </div>
                    <div class="form-value" v-if="autoFiscalIn">
                        <div class="pos-rel">
                            <el-checkbox v-model="autoReceive" @change="changeAutoReceive">机构负责人自动领用</el-checkbox>
                        </div>
                    </div>

                    <div class="form-label" v-if="showBizUnitWarehouse">
                        <label class="required">入库仓库</label>
                    </div>
                    <div class="form-value" v-if="showBizUnitWarehouse">
                        <div class="pos-rel">
                            <el-select v-model="warehouseId" class="mb10 mr5" :clearable=true>
                                <el-option v-for="item in warehouseList" :label="item.name" :value="item.id"></el-option>
                            </el-select>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="table-layout">
            <el-table class="thin" :data="goodsRecvVoucherItemList" border style="width: 100%;" @selection-change="handleSelectionChange">
                <el-table-column type="selection" width="40" align="center" fixed="left"></el-table-column>
                <el-table-column prop="title" label="商品名称" width="120" align="left"></el-table-column>
                <el-table-column prop="catName" label="分类" width="120" align="left"></el-table-column>
                <el-table-column prop="brandName" label="品牌" width="120" align="left"></el-table-column>
                <el-table-column prop="model" label="型号" width="120" align="left"></el-table-column>
                <el-table-column prop="fixedSpec" label="规格" width="120" align="left"></el-table-column>
                <el-table-column prop="wrntPeriod" label="保质期(月)" width="80" align="right"></el-table-column>
                <el-table-column prop="quantity" label="收货数量" width="80" align="right"></el-table-column>
                <el-table-column prop="useableQuantity" label="可入库数量" width="80" align="right"></el-table-column>
                <el-table-column prop="unit" label="单位" width="50" align="left"></el-table-column>
                <el-table-column prop="unit" label="管理方式" width="150" align="center">
                    <template slot-scope="rows">
                        <div v-if="rows.row.srcAssetDefId == -1">
                            <el-radio-group v-model="rows.row.assetType" @change="assetTypeChange(rows.row)">
                                <el-radio v-for="item in assetTypeList" :label="item.value">{{item.text}}</el-radio>
                            </el-radio-group>
                        </div>
                        <div v-else>{{assetTypeEnumMap[rows.row.assetType]}}</div>
                    </template>
                </el-table-column>
                <el-table-column prop="devcDefId" label="关联定义" width="250">
                    <template slot-scope="rows">
                        <div class="inline-block" v-if="rows.row.assetDefId != -1">已关联</div>
                        <div class="inline-block" v-else>未关联</div>
                        <div v-if="rows.row.srcAssetDefId == -1">
                            <a class="swb-btn-link fr inline-block" @click="delDef(rows.row)">清除</a>
                            <a class="swb-btn-link fr inline-block" @click="setDef(rows.row)">选择</a>
                            <a class="swb-btn-link fr inline-block" v-if="rows.row.assetDefId == -1 && (rows.row.assetType == 3 || (!needAudit && rows.row.assetType != 3))" @click="saveDef(rows.row)">生成定义</a>
                        </div>
                        <a class="swb-btn-link fr inline-block" v-if="rows.row.assetDefId != -1" @click="showDevcDef(rows.row.assetDefId)">查看</a>
                    </template>
                </el-table-column>
                <el-table-column prop="specialFlag" label="特种设备" width="100" align="center">
                    <template slot-scope="rows">
                        <input type="checkbox" :disabled="rows.row.assetType != 0" v-model="rows.row.specialFlag" @change="setSpecialDevice(rows.row)"/>
                    </template>
                </el-table-column>
                <el-table-column prop="leasible" label="是否可出租" width="100" align="center">
                    <template slot-scope="rows">
                        <input type="checkbox" :disabled="rows.row.assetType != 0" v-model="rows.row.leasible" @change="setLeasible(rows.row)"/>
                    </template>
                </el-table-column>
                <el-table-column prop="useableQuantity" label="入库数量" width="100" align="right">
                    <template slot-scope="rows">
                        <el-input class="text-right" type="number" v-model="rows.row.theQuantity" :disabled="rows.row.assetType != 2"></el-input>
                    </template>
                </el-table-column>
                <el-table-column prop="theUnit" label="入库单位" width="70" align="left">
                    <template slot-scope="rows">
                        <el-autocomplete v-model="rows.row.theUnit" :disabled="assetType != 2" :fetch-suggestions="((queryString, callback)=>{querySearch(queryString, callback, rows.row.catId)})"></el-autocomplete>
                    </template>
                </el-table-column>
                <el-table-column prop="batchNo" label="批次号" width="140" align="left"></el-table-column>
                <el-table-column prop="desc" label="备注" width="200" align="left">
                    <template slot-scope="rows">
                        <el-input class="textarea-value" type="textarea" v-model="rows.row.desc"></el-input>
                    </template>
                </el-table-column>
                <el-table-column label="外部系统编号" width="500" align="left" :render-header="renderInnerNo">
                    <template slot-scope="rows">
                        <swb-file-upload class="mt5 fl" fileGroup="retailerInnerNo.extract" :onBeforeUpload="onBeforeUploadInnerNo" :onProgress="onProgressInnerNo" :onDone="(event)=>{onUploadDoneInnerNo(event, rows.row.id)}" :multipleFile="false"></swb-file-upload>
                        <a class="swb-btn-link" v-if="rows.row.innerNoList != null && rows.row.innerNoList.length > 0" @click="viewInnerNo(rows.row.id)">查看({{rows.row.innerNoList.length}})</a>
                        <a class="swb-btn-link" v-if="rows.row.innerNoList != null && rows.row.innerNoList.length > 0" @click="clearInnerNo(rows.row.id)">清除</a>
                    </template>
                </el-table-column>
                <el-table-column label="操作" width="180" align="left" fixed="right">
                    <template slot-scope="rows">
                        <a v-if="ukNoMap[rows.row.shipVoucherItemId] != null" class="swb-btn swb-btn-link" @click="viewUkNo(rows.row.shipVoucherItemId)">查看商品标识码</a>
                        <a class="swb-btn swb-btn-link" @click="doDeleteStockInItem(rows.row.id)">移除</a>
                    </template>
                </el-table-column>
            </el-table>
        </div>
    </div>
</template>

<script>

    import { Utils } from '../../app.base'
    import { Vue, MsgBox, Routes } from '../../app.vues'

    import { showGoodsRecvVoucherItemListForSelectDialog } from './dialog'
    import { showMerchtDevcDefSelectDlg, openDevcDefDetailDlg, openDevcDefSaveDlg } from '../devcDef/showDlg'
    import { showAsmblAccDefSelectDlg, openAccDefSaveDlg } from '../asmblAcc/dialog'
    import { getMerchantBizParam } from '../asset/assetMain'
    //
    import goodsDelivApi from '../../api/goodsDeliv'
    import shopStockApi from '../../api/shopStock'
    import assetApi from '../../api/asset'
    import devcDefApi from '../../api/devcDef'
    import asmblAccApi from '../../api/asmblAcc'
    import retailerApi from '../../api/retailer'

    export default {
        name: 'swb-asset-stockIn-item-list',
        desc: '资产入库条目列表',
        props: {
            voucherId: {
                type: Number,
                default: null
            },
            ioFlag: {
                type: Number,
                default: null
            },
            buyerShopId: {
                type: Number,
                default: null
            },
            shipVoucherId: {
                type: Number,
                default: null
            },
            assetTypes: {
                type: Array,
                default: null
            }
        },
        data: function () {
            return {
                goodsRecvVoucherItemList: [],
                warehouseId: null,
                warehouseName: null,
                warehouseList: [],
                assetTypeList: [],
                ukNoMap: {},
                multipleSelection: [],
                assetTypeEnumMap: {},
                normalFlag: false,
                autoFiscalIn: false,
                autoReceive: false,
                principalId: null,
                autoInFiscal: false,
                lowCostFlag: false,
                showBizUnitWarehouse: false,
                needAudit: false,
            }
        },
        created: function () {
            let self = this;
            let assetType = this.assetTypes[0];
            this.lowCostFlag = assetType == 2;
//            getMerchantBizParam("asset.fiscal.auto.in.after.ready", function (result) {
//                self.autoInFiscal = Utils.isTrue(result);
//            });
            getMerchantBizParam("asset.finac.enabled", function (resultEnabled) {
                self.normalFlag = Utils.isTrue(resultEnabled);
                getMerchantBizParam("auto.fiscal.in.after.receipt.invoice.confirmed", function (resultConfirmed) {
                    self.autoInFiscal = Utils.isTrue(resultEnabled) && Utils.isTrue(resultConfirmed);
                });
            }, 2, self.buyerShopId);
            getMerchantBizParam("show.biz.unit.warehouse", function (result) { // 显示门店/机构的仓库： {}
                self.showBizUnitWarehouse = Utils.isTrue(result);
            });
            getMerchantBizParam("asset.definition.create.alter.need.audit", function (result) {  // 新增/变更资产定义是否需要审核
                self.needAudit = Utils.isTrue(result);
            }, 0);
            //
            this.getVendorGoodsUknoList();
            this.getWarehouseList();
            this.assetTypeList = getEnumList("assetType") || [];
            this.assetTypeEnumMap = getEnumMap("assetType", "value2text");
            this.getRetailerCom();
        },
        methods: {
            getRetailerCom(){
                let self = this;
                retailerApi.getRetailerCom({}, function (result) {
                    if(result.type == 'info') {
                        self.principalId = result.data.principalId;
                    }
                });
            },
            changeAutoReceive: function () {
                if(Utils.isNoB(this.principalId)) {
                    this.autoReceive = false;
                    MsgBox.warning("请先设置机构责任人");
                }
            },
            doDownloadInnerNoModel(){
                let pageUrl = "/api/shop/devc/vendor/goods/ukno/innerno/model/downLoad";
                let filter = {};
                //
                pageUrl = Utils.makeUrl(pageUrl, filter);
                Utils.setPageUrl(getAppUrl(pageUrl));
            },
            wrntPeriodChange: function (goodsRecvVoucherItem) {
                let wrntPeriod = goodsRecvVoucherItem.wrntPeriod;
                if(!Utils.isNaturalStr(wrntPeriod)) {
                    goodsRecvVoucherItem.wrntPeriod = null;
                    MsgBox.warning("质保期必须为大于0的整数!");
                }
            },
            expectedLifeChange: function (goodsRecvVoucherItem) {
                let expectedLife = goodsRecvVoucherItem.expectedLife;
                if(!Utils.isNaturalStr(expectedLife)) {
                    goodsRecvVoucherItem.expectedLife = null;
                    MsgBox.warning("使用年限(月)必须为大于0的整数!");
                }
                this.goodsRecvVoucherItemList = Utils.merge([], this.goodsRecvVoucherItemList);
            },
            assetTypeChange(row){
                console.log(row.id);
                row.theUnit = row.unit;
                row.theQuantity = row.useableQuantity;
                row.specialFlag = false;
                row.leasible = false;
                if(row.srcAssetDefId == -1 && row.assetDefId != -1) {
                    row.assetDefId = -1;
                    row.catId = row.srcData.catId;
                    row.catName = row.srcData.catName;
                    row.brandId = row.srcData.brandId;
                    row.brandName = row.srcData.brandName;
                    row.model = row.srcData.model;
                    row.fixedSpec = row.srcData.fixedSpec;
                    row.title = row.srcData.title;
                    row.theUnit = row.srcData.theUnit;
                    row.unit = row.srcData.theUnit;
                    row.srcData = null;
                }
                this.goodsRecvVoucherItemList = Utils.merge([], this.goodsRecvVoucherItemList);
            },
            getWarehouseList(){
                let self = this;
                let buyerShopId = self.buyerShopId;
                let postData = {};
                if(!Utils.isNoB(buyerShopId)) {
                    postData.filterItems = {
                        retailerShopId: buyerShopId
                    };
                }
                let msgBoxDlg = MsgBox.loading();
                shopStockApi.getShopWarehouseNotPageList(postData, function (result) {
                    msgBoxDlg.close();
                    if(result.type == 'info') {
                        let warehouseList = result.data;
                        if(warehouseList.length > 0) {
                            warehouseList.forEach(function (row) {
                                if(row.defaulted == true) {
                                    self.warehouseId = row.id;
                                }
                            })
                        }
                        self.warehouseList = Utils.merge([], warehouseList);
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            // 仓库校验
            checkNull: function (rule, value, callback) {
                if(Utils.isNoB(value)) {
                    callback(new Error('不能为空!'));
                } else {
                    callback();
                }
            },
            // 选择收货单条目(资产入库条目)
            toSelectAssetStockInItem: function (voucherId, ioFlag, selectItems) {
                let self = this;
                let useFor = 'assetStockIn'; // 用途，用于资产入库
                let assetTypes = self.assetTypes;
                showGoodsRecvVoucherItemListForSelectDialog(voucherId, null, ioFlag, false, selectItems, useFor, assetTypes, function (recvItems) {
                    if(!Utils.isNoB(recvItems) && recvItems.length > 0) {
                        // 入库仓库默认选择第一个
                        for(let i = 0; i < recvItems.length; i++) {
                            let item = recvItems[i];
                            let quantity = item.quantity;
                            let exchgSumQuantity = item.exchgSumQuantity;
                            exchgSumQuantity = exchgSumQuantity == null ? 0 : exchgSumQuantity;
                            let returnSumQuantity = item.returnSumQuantity;
                            returnSumQuantity = returnSumQuantity == null ? 0 : returnSumQuantity;
                            item.useableQuantity = quantity - exchgSumQuantity - returnSumQuantity - item.assetInQuantity;
                            item.theQuantity = item.useableQuantity;
                            item.theUnit = item.unit;
                            item.batchNo = item.batchNo || '';
                            //
                            item.specialFlag = false;   // 特种设备
                            item.unrepairable = false;  // 不可报修
                            item.srcAssetDefId = item.assetDefId;
                        }
                        self.goodsRecvVoucherItemList = recvItems;
                    }
                });
            },
            // 移除操作
            doDeleteStockInItem: function (id) {
                if(this.goodsRecvVoucherItemList != null && this.goodsRecvVoucherItemList.length > 0) {
                    for(let i = 0; i < this.goodsRecvVoucherItemList.length; i++) {
                        let goodsRecvVoucherItem = this.goodsRecvVoucherItemList[i];
                        if(id == goodsRecvVoucherItem.id) {
                            this.goodsRecvVoucherItemList.splice(i, 1);
                            break;
                        }
                    }
                }
            },
            setSpecialDevice(goodsRecvVoucherItem) {
                let goodsRecvVoucherItemList = this.goodsRecvVoucherItemList;
                for(let i = 0; i < goodsRecvVoucherItemList.lenth; i++) {
                    let item = goodsRecvVoucherItemList[i];
                    if(item.id === goodsRecvVoucherItem.id) {
                        item.specialFlag = goodsRecvVoucherItem.specialFlag;
                        item.unrepairable = goodsRecvVoucherItem.unrepairable;
                    }
                }
                this.goodsRecvVoucherItemList = Utils.merge([], this.goodsRecvVoucherItemList);
            },
            setLeasible(goodsRecvVoucherItem) {
                let goodsRecvVoucherItemList = this.goodsRecvVoucherItemList;
                for(let i = 0; i < goodsRecvVoucherItemList.lenth; i++) {
                    let item = goodsRecvVoucherItemList[i];
                    if(item.id == goodsRecvVoucherItem.id) {
                        item.leasible = goodsRecvVoucherItem.leasible;
                    }
                }
                this.goodsRecvVoucherItemList = Utils.merge([], this.goodsRecvVoucherItemList);
            },
            // 返回
            getDlgResult: function () {
                let self = this;
                let result = {};
                //
                if(Utils.isNoB(self.warehouseId)) {
                    result.type = 'warn';
                    result.message = "请选择入库仓库！";
                    return result;
                } else {
                    self.warehouseList.forEach(function (warehouse) {
                        if(warehouse.id == self.warehouseId) {
                            self.warehouseName = warehouse.name;
                        }
                    });
                }
                //
                let goodsRecvVoucherItemList = self.goodsRecvVoucherItemList;
                if(goodsRecvVoucherItemList != null && goodsRecvVoucherItemList.length > 0) {
                    //
                    let isOk = true;
                    goodsRecvVoucherItemList.forEach(function (item) {
                        if(!Utils.isNoB(item.theUnit) && item.theUnit.length > 5) {
                            isOk = false;
                        }
                    });
                    if(!isOk) {
                        result.type = 'warn';
                        result.message = "入库单位最多5个字符";
                        return result;
                    }
                    for(let i = 0; i < goodsRecvVoucherItemList.length; i++) {
                        let goodsRecvVoucherItem = goodsRecvVoucherItemList[i];
                        if(self.assetType == 2) {
                            goodsRecvVoucherItem.assetType = 2;
                            if(Utils.isNoB(goodsRecvVoucherItem.theUnit)) {
                                result.type = 'warn';
                                result.message = "请输入正确的入库单位！";
                                return result;
                            }
                        }
                        let theQuantity = goodsRecvVoucherItem.theQuantity;
                        if(Utils.isNoB(theQuantity) || theQuantity == 0) {
                            result.type = 'warn';
                            result.message = "请输入正确的入库数量！";
                            return result;
                        }
                        goodsRecvVoucherItem.useableQuantity = theQuantity;
                        //
                        let innerNoList = goodsRecvVoucherItem.innerNoList;
                        if(!Utils.isNoB(innerNoList) && innerNoList.length > 0 && innerNoList.length > theQuantity) {
                            result.type = 'warn';
                            result.message = "外部系统编号数量不能大于入库数量！";
                            return result;
                        }
                        if(goodsRecvVoucherItem.assetDefId == -1) {
                            result.type = 'warn';
                            result.message = "请关联定义！";
                            return result;
                        }
                    }
                    let resData = {
                        warehouseId: self.warehouseId,
                        warehouseName: self.warehouseName,
                        goodsRecvVoucherItemList: goodsRecvVoucherItemList,
                        autoFiscalIn: self.autoFiscalIn,
                        autoReceive: self.autoReceive
                    };
                    result.type = 'info';
                    result.data = resData;
                } else {
                    result.type = 'warn';
                    result.message = "请至少选择一个条目！";
                }
                return result;
            },
            querySearch(queryString, callback, catId) {
                let postData = {
                    retailerId: null,// 后台处理了
                    goodsCatId: catId,
                    lowCostFlag: true
                };
                assetApi.getAssetCatUnitList(postData, function (result) {
                    if(result.type == 'info') {
                        let catUnitList = result.data;
                        let showCatUnitList = [];
                        catUnitList.forEach(function (item) {
                            showCatUnitList.add({
                                value: item
                            });
                        });
                        callback(showCatUnitList);
                    } else {
                        Toast.show(result.message);
                    }
                });
            },
            getVendorGoodsUknoList(){
                let self = this;
                let postData = {
                    filterItems: {
                        shipVoucherId: self.shipVoucherId,
                        invalid: false
                    }
                };
                let msgBoxDlg = MsgBox.loading();
                goodsDelivApi.getMerchtGoodsUknoListByFilter(postData, function (result) {
                    msgBoxDlg.close();
                    if(result.type == 'info') {
                        let ukNoList = result.data;
                        if(!Utils.isNoB(ukNoList) && ukNoList.length > 0) {
                            let ukNoMap = {};
                            ukNoList.forEach(function (ukNo) {
                                let key = ukNo.shipVoucherItemId;
                                if(ukNoMap[key] == null) {
                                    ukNoMap[key] = [ukNo];
                                } else {
                                    let nos = ukNoMap[key];
                                    nos.push(ukNo);
                                    ukNoMap[key] = nos;
                                }
                            });
                            self.ukNoMap = ukNoMap;
                        }
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            //上传前（进行验证检查）处理，可以返回false取消上传
            onBeforeUploadInnerNo: function (fileItems, uploader) {
                if(fileItems.length === 0) {
                    MsgBox.warning('请选择要上传的文件！');
                    return false;
                }
            },
            //上传进度处理
            onProgressInnerNo: function (progress) {
                this.percentage = Math.floor((progress.loaded / progress.total) * 100);
            },
            //上传完毕处理（根据result.type判断是否有误）
            onUploadDoneInnerNo: function (result, id) {
                let self = this;
                if(result.type === 'info') {
                    let resultData = result.data;
                    let fileList = resultData.files || [];
                    //
                    let file = fileList[0];
                    if(file.type == "info") {
                        let extra = file.extra;
                        let innerNoList = extra.retailerInnerNoList;
                        if(!Utils.isNoB(innerNoList) && innerNoList.length > 0) {
                            let goodsRecvVoucherItemList = this.goodsRecvVoucherItemList;
                            let goodsRecvVoucherItem = goodsRecvVoucherItemList.find(function (item) {
                                return item.id == id;
                            });
                            goodsRecvVoucherItem.innerNoList = innerNoList;
                            this.goodsRecvVoucherItemList = Utils.merge([], this.goodsRecvVoucherItemList);
                        }
                    } else {
                        self.$message.warning(file.message);
                    }
                } else {
                    self.$message.warning(result.message);
                }
            },
            viewUkNo(id){
                let ukNoMap = this.ukNoMap;
                let ukNoList = ukNoMap[id];
                //
                let theDlg = Vue.$showDialog({
                    title: '查看商品标识码',
                    okVisible: false,
                    showCloseBtn: true,
                    cancelText: '关闭',
                    width: 500,
                    height: 800,
                    template: '<div class="table-layout">' +
                    '   <el-table :data="ukNoList" border style="width: 100%">' +
                    '        <el-table-column label="商品标识码" align="left">' +
                    '           <template slot-scope="rows">' +
                    '               <span>{{rows.row.no}}</span>' +
                    '           </template>' +
                    '        </el-table-column>' +
                    '   </el-table>' +
                    '</div>',
                    data: {
                        ukNoList: ukNoList
                    }
                });
            },
            viewInnerNo(id){
                let goodsRecvVoucherItemList = this.goodsRecvVoucherItemList;
                let goodsRecvVoucherItem = goodsRecvVoucherItemList.find(function (item) {
                    return item.id == id;
                });
                let innerNoList = goodsRecvVoucherItem.innerNoList;
                //
                let theDlg = Vue.$showDialog({
                    title: '查看外部系统编号',
                    okVisible: false,
                    showCloseBtn: true,
                    cancelText: '关闭',
                    width: 500,
                    height: 800,
                    template: '<div class="table-layout">' +
                    '   <el-table :data="innerNoList" border style="width: 100%">' +
                    '        <el-table-column label="外部系统编号" align="left">' +
                    '           <template slot-scope="rows">' +
                    '               <span>{{rows.row}}</span>' +
                    '           </template>' +
                    '        </el-table-column>' +
                    '   </el-table>' +
                    '</div>',
                    data: {
                        innerNoList: innerNoList
                    }
                });
            },
            clearInnerNo(id){
                let goodsRecvVoucherItemList = this.goodsRecvVoucherItemList;
                let goodsRecvVoucherItem = goodsRecvVoucherItemList.find(function (item) {
                    return item.id == id;
                });
                goodsRecvVoucherItem.innerNoList = [];
                this.goodsRecvVoucherItemList = Utils.merge([], this.goodsRecvVoucherItemList);
            },
            renderInnerNo(h){
                let self = this;
                return h('span', [
                    h('span', {}, '外部系统编号'),
                    h('span', {}, '('),
                    h('a', {
                        class: 'swb-btn swb-btn-link',
                        on: {
                            click: function () {
                                self.doDownloadInnerNoModel();
                            }
                        }
                    }, '下载模版'),
                    h('span', {}, ')'),
                ]);
            },
            handleSelectionChange(val) {
                this.multipleSelection = val;
            },
            setDef(row){
                let self = this;
                let assetType = row.assetType;
                let postData = {};
                postData.assetType = assetType;
                //
                if(assetType == 3) {
                    showAsmblAccDefSelectDlg({
                        filter: {},
                        checkBox: false
                    }, function (devcDef, dlg) {
                        dlg.close();
                        row.assetDefId = devcDef.id;
                        row.srcData = Utils.merge({}, row);
                        row.catId = devcDef.catId;
                        row.catName = devcDef.catName;
                        row.brandId = devcDef.brandId;
                        row.brandName = devcDef.brandName;
                        row.model = devcDef.model;
                        row.fixedSpec = devcDef.fixedSpec;
                        row.title = devcDef.title;
                        row.theUnit = devcDef.theUnit;
                        row.unit = devcDef.theUnit;
                        self.goodsRecvVoucherItemList = Utils.merge([], self.goodsRecvVoucherItemList);
                    });
                } else {
                    showMerchtDevcDefSelectDlg({
                        catId: row.catId,
                        brandId: row.brandId,
                        modelSpec: row.model + '' + row.fixedSpec,
                        assetType: assetType,
                        normalized: Utils.isTrue(self.normalFlag) ? true : null
                    }, function (devcDef, dlg) {
                        dlg.close();
                        row.assetDefId = devcDef.id;
                        row.srcData = Utils.merge({}, row);
                        row.catId = devcDef.catId;
                        row.catName = devcDef.catName;
                        row.brandId = devcDef.brandId;
                        row.brandName = devcDef.brandName;
                        row.model = devcDef.model;
                        row.fixedSpec = devcDef.fixedSpec;
                        row.title = devcDef.title;
                        row.theUnit = devcDef.theUnit;
                        row.unit = devcDef.theUnit;
                        self.goodsRecvVoucherItemList = Utils.merge([], self.goodsRecvVoucherItemList);
                    });
                }
            },
            delDef(row){
                if(row.assetDefId != -1) {
                    row.assetDefId = -1;
                    row.catId = row.srcData.catId;
                    row.catName = row.srcData.catName;
                    row.brandId = row.srcData.brandId;
                    row.brandName = row.srcData.brandName;
                    row.model = row.srcData.model;
                    row.fixedSpec = row.srcData.fixedSpec;
                    row.title = row.srcData.title;
                    row.theUnit = row.srcData.theUnit;
                    row.unit = row.srcData.unit;
                    row.srcData = null;
                }
                this.goodsRecvVoucherItemList = Utils.merge([], this.goodsRecvVoucherItemList);
            },
            // 生成定义
            saveDef(row){
                let self = this;
                let assetType = getEnumInfoWith("assetType", "value", row.assetType);
                //
                let devcDef = row;
                devcDef.name = row.title;
                devcDef.model = row.model;
                devcDef.fixedSpec = row.fixedSpec;
                let title = row.title;
                if(!Utils.isNoB(row.model)) {
                    title = title + row.model;
                }
                if(!Utils.isNoB(row.fixedSpec)) {
                    title = title + row.fixedSpec;
                }
                devcDef.title = title;
                devcDef.theUnit = row.unit;
                devcDef.createDef = true;
                //
                if(!Utils.isNoB(assetType) && assetType.name == 'AsmblAcc') {
                    devcDef.centBuyMode = false;
                    openAccDefSaveDlg({
                        row: devcDef,
                        buildFlag: true
                    }, function (result, theDlg) {
                        theDlg.close();
                        let postData = {};
                        postData.assetType = row.assetType;
                        let brandId = row.brandId == null ? -1 : row.brandId;
                        postData.catId = row.catId;
                        postData.brandId = brandId;
                        postData.theUnit = row.theUnit;
                        postData.skuId = row.skuId;
                        postData.catName = row.catName;
                        postData.brandName = row.brandName;
                        postData.createFlag = true;
                        let msgBoxDlg = MsgBox.loading();
                        asmblAccApi.getAsmblAccDefByUK(postData, function (result) {
                            msgBoxDlg.close();
                            if(result.type == 'info') {
                                let accDef = result.data;
                                row.assetDefId = accDef.id;
                                row.srcData = Utils.merge({}, row);
                                row.catId = accDef.catId;
                                row.catName = accDef.catName;
                                row.brandId = accDef.brandId;
                                row.brandName = accDef.brandName;
                                row.model = accDef.model;
                                row.fixedSpec = accDef.fixedSpec;
                                row.title = accDef.title;
                                row.theUnit = accDef.theUnit;
                                row.unit = accDef.theUnit;
                                self.goodsRecvVoucherItemList = Utils.merge([], self.goodsRecvVoucherItemList);
                            } else {
                                MsgBox.warning(result.message);
                            }
                        });
                    });
                } else {
                    devcDef.centBuyRequired = false;
                    devcDef.vendorUknoFlag = false;
                    devcDef.setupFlag = false;
                    devcDef.asmblFlag = false;
                    devcDef.asmblWhileSetup = false;
                    devcDef.stockFifo = false;
                    devcDef.purchFlag = true;
                    let params = {
                        row: devcDef,
                        normalized: Utils.isTrue(self.normalFlag),
                        assetTypeDisabled: true,
                        purchFlagDisabled: true,
                    };
                    openDevcDefSaveDlg(params, function (result, theDlg) {
                        theDlg.close();
                        let postData = {};
                        postData.assetType = row.assetType;
                        let brandId = row.brandId == null ? -1 : row.brandId;
                        postData.catId = row.catId;
                        postData.brandId = brandId;
                        postData.theUnit = row.theUnit;
                        postData.skuId = row.skuId;
                        postData.catName = row.catName;
                        postData.brandName = row.brandName;
                        postData.normalized = Utils.isTrue(self.normalFlag);
                        postData.createFlag = true;
                        let msgBoxDlg = MsgBox.loading();
                        devcDefApi.getMerchtDevcDefInfoByUK(postData, function (result) {
                            msgBoxDlg.close();
                            if(result.type == 'info') {
                                let devcDef = result.data;
                                row.assetDefId = devcDef.id;
                                row.srcData = Utils.merge({}, row);
                                row.catId = devcDef.catId;
                                row.catName = devcDef.catName;
                                row.brandId = devcDef.brandId;
                                row.brandName = devcDef.brandName;
                                row.model = devcDef.model;
                                row.fixedSpec = devcDef.fixedSpec;
                                row.title = devcDef.title;
                                row.theUnit = devcDef.theUnit;
                                row.unit = devcDef.theUnit;
                                self.goodsRecvVoucherItemList = Utils.merge([], self.goodsRecvVoucherItemList);
                            } else {
                                MsgBox.warning(result.message);
                            }
                        });
                    });
                }
            },
            showDevcDef(id){
                openDevcDefDetailDlg(id);
            }
        }
    }
</script>






// WEBPACK FOOTER //
// src/compo/order/AssetStockInItemList.vue